import {
  ChoiceGroup,
  DefaultButton,
  Icon,
  PrimaryButton,
  Spinner,
  SpinnerSize,
  TextField,
} from "@fluentui/react";
import { useFormik } from "formik";
import React, { useEffect, useState, useContext, useCallback, act } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Formik, Form ,FormikProvider} from 'formik';
import {
  AuthRoutes,
  APIs,
  ACTIONS,
  USERTYPES,
  TOAST_TYPE,
} from "../../constants/Constants";
import { FirmSchema } from "../../Schemas/FirmSchema";
import {
  addHospital,
  addProject,
  editFirmSettings,
  editProjectSettings,
  getBucketDetails,
  getConfigurationDetails,
  getFirmSettingDetails,
  getHospitalDetails,
  getImage,
  saveFirmSettingDetails,
  editFirmHeaderTemplate,
  previewSampleReport,
} from "../../service/FirmServices";
import { eventBus } from "../../pages/Annotations/helper/initialData";
import HeaderFileCheck from "./components/HeaderFileChecks/HeaderFileChecks";
import { t } from "i18next";
import {
  InitialData,
  editBreadCrumbItems,
  addbreadCrumbItems,
  passwordProtectedOptions,
  viewBreadCrumbItems,
} from "../Firm/helpers/InitialData";
import {
  adminFirmEditDataModal,
  firmDataModal,
  buildSampleReportPreviewDto,
} from "../Hospital/helpers/DataModal";
import HospitalDetailsSection from "./components/HospitalDetailsSection/HospitalDetailsSection";
import {
  CXR_TRIAGE_MAX_AGE,
  getCxrTriageModeMinAge,
  isCxrTriageMinAgeValid,
} from "./helpers/CxrTriageMinAge";
import "./firm.css";
import ContactDetailsSection from "./components/ContactDetailsSection/ContactDetailsSection";
import PasswordProtectedSection from "./components/PasswordProtectionSection/PasswordProtectionSection";
import { editTabStatusInitialIcon } from "./helpers/InitialData";
import firmContext from "../../context/firms/FirmContext";
import userContext from "../../context/users/UserContext";
import TabContainer from "../../components/TabContainer/TabContainer";
import HospitalSettings from "./components/HospitalSettings/HospitalSettings";
import { addTabStatusInitialValue } from "../User/helpers/InitialData";
import CustomTab from "../../components/TabContainer/CustomTab";
import FirmTechnicianList from "./FirmTechnician/FirmTechnicianList";
import FirmDoctorList from "./FirmDoctor/FirmDoctorList";
import { getFirmTabs } from "./helpers/FirmTabs";
import { Country, State, City } from "country-state-city";
import loaderContext from "../../context/loader/LoaderContext";
import NotAllowed from "../../components/NotAllowed";
import DialogBox from "../../components/Modal/DialogBox";
import toastContext from "../../context/toast/ToastContext";
import { getEnv } from '../../helpers/EnvHelper';

const Firm = (props) => {
  let enterprise =
    getEnv("REACT_APP_ENTERPRISE_PLATFORM") == "true" ||
    getEnv("REACT_APP_ENTERPRISE_PLATFORM") == true
      ? true
      : false;
  const { roles, loadByUsername, authenticated, firmId, checkForUserAccess, routeToNodeEnabled,enableReportAndHeaderTemplateConfigurations, defaultCountry: tenantDefaultCountry } =
    useContext(userContext);

  const {
    errorContactState,
    setErrorContactState,
    resetValues,
    validateContact,
    validateHospitalDetails,
    validateProjectsDetails,
    validateHospitalSettings,
    tabStatus,
    setTabStatus,
    validateConfigureSettings,
    validateOtherSettings,
    validateAutoAssignmentSettings,
    setFirmGlobalErrorState,
    firmGlobalErrorState,
    validatePacsNode,
    validateChannels,
  } = useContext(firmContext);
  const { showSuccessToast, setSuccessToast } = useContext(userContext);
  const { ref, refAnnotation, setLoaderRunning, setLoaderAnnotationRunning } =
    useContext(loaderContext);
  const { showToastv2 } = useContext(toastContext);
  const [selectedValue, setSelectedValue] = useState(1);
  const [prevState, setPrevState] = useState("0");
  const [totalTabs, setTotalTabs] = useState(1);
  const infoIcon = {
    iconName: "Info",
    style: { fontSize: 13, lineHeight: 1.5 },
  };
  const location = useLocation();
  const navigate = useNavigate();
  const [action, setAction] = useState(props.action);
  let { state } = location;
  const [submitClicked, setSubmitClick] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loadingState, setLoadingState] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [breadCrumbItems, setBreadCrumBItems] = useState([]);
  const [tabStatusInitialValue, setTabStatusInitialValue] = useState(
    addTabStatusInitialValue
  );
  // const [tabStatus, setTabStatus] = useState(action=="EDIT"?editTabStatusInitialIcon:tabStatusInitialValue);
  const [headerImageValue, setHeaderImageValue] = useState("");
  const [footerImageValue, setFooterImageValue] = useState("");
  const [signature2ImageValue, setSignature2ImageValue] = useState("");
  const [signature3ImageValue, setSignature3ImageValue] = useState("");
  const [watermarkImageValue, setWatermarkImageValue] = useState("");
  const [editConfigurationSetting, setEditConfigurationSetting] =
    useState(false);
  const [hospitalDetails, setHospitalDetails] = useState({});
  const [hospitalUserList, setHospitalUserList] = useState([]);
  const [hospitalDoctorList, setHospitalDoctorList] = useState([]);
  const [modalityList, setModalityList] = useState([]);
  const [modalityWithSubModalityList, setModalityWithSubModalityList] =
    useState([]);
  const [historyModalityList, setHistoryModalityList] = useState([]);
  const [isMinimal, setIsMinimal] = useState(false);
  const [firmTechnicianOwnFirm, setFirmTechnicianOwnFirm] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(() => {
    const code = (tenantDefaultCountry || "in").toUpperCase();
    const country = Country.getCountryByCode(code) || Country.getCountryByCode("IN");
    return {
      value: country.isoCode,
      label: country.name,
    };
  });
  const [hospitalCheckList, setHospitalCheckList] = useState([]);
  const [firmListForProviders, setFirmListForProviders] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");

  // Tenant default country is fetched asynchronously in UserState; if it resolves
  // after this component mounts, the useState initializer above will have used the
  // "in" fallback. Sync once it arrives, but only in ADD mode (EDIT/VIEW rely on
  // handleRegion to set country from saved firm data) and only when state/city are
  // still empty (user hasn't started filling — avoids clobbering manual selection).
  useEffect(() => {
    if (props.action !== ACTIONS.ADD) return;
    if (!tenantDefaultCountry) return;
    const country = Country.getCountryByCode(tenantDefaultCountry.toUpperCase());
    if (!country) return;
    if (selectedCountry?.value === country.isoCode) return;
    if (selectedState || selectedCity) return;
    setSelectedCountry({ value: country.isoCode, label: country.name });
  }, [tenantDefaultCountry, props.action]);
  const [currFirmId, setcurrFirmId] = useState(
    searchParams.get("firmId") ? parseInt(searchParams.get("firmId")) : ""
  );
  const [firmType, setFirmType] = useState(
    props.action === ACTIONS.EDIT || props.action === ACTIONS.VIEW
      ? parseInt(searchParams.get("type"))
      : ""
  );
  const [viewWarningOnly, setViewWarningOnly] = useState(
    searchParams.get("viewWarningOnly") == "true" ? true : false
  );
  const ownFirm =
    currFirmId == "" || currFirmId == null || currFirmId == undefined
      ? true
      : false;
  const [showSelectModalityDialog, setShowSelectModalityDialog] =
    useState(false);
  const [noSelectionErrorMessage, setNoSelectionErrorMessage] = useState("");
  const [clientId, setClientId] = useState(0);
  const [userFirmId, setUserFirmId] = useState(0);
  const [headerImageFileName, setHeaderImageFileName] = useState("");
  const [footerImageFileName, setFooterImageFileName] = useState("");
  const [isHeaderFileDeleted, setIsHeaderFileDeleted] = useState(false);
  const [isFooterFileDeleted, setIsFooterFileDeleted] = useState(false);
  const [isSignatureFile2Deleted, setIsSignatureFile2Deleted] = useState(false);
  const [isSignatureFile3Deleted, setIsSignatureFile3Deleted] = useState(false);
  const [isWatermarkImageDeleted, setIsWatermarkImageDeleted] = useState(false);
  const [selectedModalityAndSubModality, setSelectedModalityAndSubModality] =
    useState([]);
  const [show, setShow] = useState(true);
  const [autoAssignEnabled, setAutoAssignEnabled] = useState(false);
  const [pediatricAssignmentEnabled, setPediatricAssignmentEnabled] = useState(false);
  const [selectedPediatricModalityId, setSelectedPediatricModalityId] = useState([]);
  const [showPriorsStudiesList, setShowPriorsStudiesList] = useState([]);
  const [selectedHeaderTemplateId, setSelectedHeaderTemplateId] = useState(null);
  const [previousUnassignmentModalityIds, setPreviousUnassignmentModalityIds] = useState([]);

  const isVdcPlatform = (getEnv("REACT_APP_VDC_PLATFORM")=="true"||getEnv("REACT_APP_VDC_PLATFORM")==true)?true:false;
  const fetchImage = async (flagImage, imageName, apiUrl) => {
    let response = await getImage(imageName, apiUrl);
    let base64Flag = "data:image/jpeg;base64,";
    if (response.status == 200) {
      if (flagImage == "headerImage") {
        setHeaderImageValue(base64Flag + response.data.data);
      } else if (flagImage == "footerImage") {
        setFooterImageValue(base64Flag + response.data.data);
      } else if (flagImage == "signature2Image") {
        setSignature2ImageValue(base64Flag + response.data.data);
      } else if (flagImage == "signature3Image") {
        setSignature3ImageValue(base64Flag + response.data.data);
      } else if (flagImage == "watermarkImage") {
        setWatermarkImageValue(base64Flag + response.data.data);
      }
    }
  };

  useEffect(() => {
    if (!authenticated) {
      loadByUsername();
    }
    getBreadCrumbItems();
  }, [roles, firmType]);

  useEffect(() => {
    checkForUserAccess()
  }, [roles[0]]);

  const [selectedRadiologistMap, setSelectedRadiologistMap] = useState(new Map());
  const [radiologistList, setRadiologistList] = useState([]);
  const [checkAllRadiologist, setCheckAllRadiologist] = useState(false);

  const [selectedSupervisorMap, setSelectedSupervisorMap] = useState(new Map());
  const [supervisorList, setSupervisorList] = useState([]);
  const [checkAllSupervisor, setCheckAllSupervisor] = useState(false);

  const [pacsNodeList, setPacsNodeList] = useState([]);

  const [availablePacsList, setAvailablePacsList] = useState([]);
  const [checkAllPacs, setCheckAllPacs] = useState(false);
  const [selectedPacsList, setSelectedPacsList] = useState([]);

  const [bucketList, setBucketList] = useState([]);

  const prepareRadiologistList = (list, checkList) => {
    setRadiologistList(list);

    checkList.map((radiologist) => {
      setSelectedRadiologistMap((prevMap) => {
        const newMap = new Map(prevMap);
        newMap.set(
          parseInt(radiologist.userId),
          radiologist.modalityIds.map(Number)
        );
        return newMap;
      });
    });

    let result = [];

    list.map((l) => {
      const mapping = checkList.filter((cl) => cl.userId == l.id);
      result.push({
        userId: l.id,
        name: l.username,
        modalityIds: mapping.length === 0 ? [] : mapping[0]?.modalityIds,
      });
    });

    return result;
  };

  const prepareSupervisorList = (list, checkList) => {
    setSupervisorList(list);

    checkList.map((supervisor) => {
      setSelectedSupervisorMap((prevMap) => {
        const newMap = new Map(prevMap);
        newMap.set(
          parseInt(supervisor.userId),
          supervisor.modalityIds.map(Number)
        );
        return newMap;
      });
    });
    let result = [];

    list.map((l) => {
      const mapping = checkList.filter((cl) => cl.userId == l.id);
      result.push({
        userId: l.id,
        name: l.username,
        modalityIds: mapping.length === 0 ? [] : mapping[0]?.modalityIds,
      });
    });

    return result;
  };

  const formattedAutoAssignModality = () => {
    return selectedModalityAndSubModality;
  };

  const preSelectedAutoAssignModality = (
    autoAssignModalityWithSubModalityIds
  ) => {
    let list1 = [];
    autoAssignModalityWithSubModalityIds.map((modality, index) => {
      list1.push({
        modalityId: modality.modalityId,
        subModalities: modality.subModalities.map((sm) => sm.id),
      });
    });
    setSelectedModalityAndSubModality(list1);
    // setSelectedModality(list1.map((m)=>m.modalityId));
  };

  const [editFirmResponseState, setEditFirmResponseState] = useState(null);
  const [firmDataState, setFirmDataState] = useState(null);

  const setValuesForFirm = async (data, editFirmResponse) => {
    const bucketConfigSettings = data?.firmDto?.bucketConfigSettings || {};

    const modalityBuckets = Object.entries(bucketConfigSettings).length > 0
    ? Object.entries(bucketConfigSettings).map(([modality, bucketConfiguration]) => ({
        modality,
        bucketConfiguration,
      }))
    : [{ modality: "", bucketConfiguration: "" }];

    setValues({
      id: data.firmDto.id,
      name: props.firmMode === "projects" ? data?.firmDto?.name.replace(/^(\__p_)/, "") : data?.firmDto?.name,
      code: data?.firmDto?.code,
      address: data?.firmDto?.address,
      country: data?.firmDto?.country,
      state: data?.firmDto?.state,
      city: data?.firmDto?.city,
      customerSupportNumber:data?.firmDto?.customerSupportNumber,
      active: data.firmDto.active,
      firmType: data.firmDto?.firmType,
      firmRole: data.firmDto?.firmRole,
      password_protected: data?.firmDto?.password_protected,
      triageCTStudies: data?.firmDto?.triageCTStudies,
      triageXRAYStudies: data?.firmDto?.triageXRAYStudies,
      addTimeToReport: data?.firmDto?.addTimeToReport,
      addDateToReport: data?.firmDto?.addDateToReport,
      addSupervisorSignature: data?.firmDto?.addSupervisorSignature,
      isDOC: data?.firmDto?.isDOC,
      isDOCX: data?.firmDto?.isDOCX,
      isPDF: data?.firmDto?.isPDF,
      isPDFWithImage: data?.firmDto?.isPDFWithImage,
      isPDFWithKeyImage: data?.firmDto?.isPDFWithKeyImage,
      isDOCXWithKeyImage: data?.firmDto?.isDOCXWithKeyImage,
      isMinimalAccount: data?.firmDto?.isMinimalAccount,
      qcEnabled:
        editFirmResponse?.data.data.qcSettingsResponseDto.qcSettingDto
          .qcEnabled == 1
          ? true
          : false,
      preliminaryQcEnabled:
        editFirmResponse?.data.data.qcSettingsResponseDto.qcSettingDto
          .preliminaryQcEnabled == 1
          ? true
          : false,
      masterStudyReportId: data?.firmDto?.masterStudyReportId || 
                         editFirmResponse?.data?.data?.masterStudyReportId || 
                         data?.masterStudyReportId || null,
      twoSignaturesAllowed:
        editFirmResponse?.data.data.qcSettingsResponseDto.qcSettingDto
          .twoSignaturesAllowed == 0
          ? false
          : true,
      enableQCAutoAssignment: 
        editFirmResponse?.data.data.qcSettingsResponseDto.qcSettingDto
          .enableQCAutoAssignment == 0
          ? false
          :true,
      modalityIds:
        editFirmResponse?.data.data.qcSettingsResponseDto.qcSettingDto.modalityIds.filter(
          (m) => m != null
        ),
      reportHeaderDto: {
        headerImage: data?.firmDto?.reportHeaderDto.headerImage,
        footerImage: data?.firmDto?.reportHeaderDto.footerImage,
        headerImageUrl: data?.firmDto?.reportHeaderDto.headerImageUrl,
        footerImageUrl: data?.firmDto?.reportHeaderDto.footerImageUrl,
        isHeaderImageDeleted: data?.firmDto?.reportHeaderDto.isHeaderImageDeleted ? 1 : 0,
        isFooterImageDeleted: data?.firmDto?.reportHeaderDto.isFooterImageDeleted ? 1 : 0,
      },
      signature2Dto: {
        signatureFile2: data?.firmDto?.signature2Dto.signatureImageUrl,
        signatureText:
          data?.firmDto?.signature2Dto.signatureText == null
            ? ""
            : data.firmDto.signature2Dto.signatureText,
        signature2Text:
          data?.firmDto?.signature2Dto.signatureText == null
            ? ""
            : data.firmDto.signature2Dto.signatureText,
        isSignatureImageDeleted: data?.signature3Dto?.isSignatureImageDeleted ? 1 : 0
      },
      signature3Dto: {
        signatureFile3: data?.firmDto?.signature3Dto.signatureImageUrl,
        signatureText:
          data?.firmDto?.signature3Dto.signatureText == null
            ? ""
            : data.firmDto.signature3Dto.signatureText,
        signature3Text:
          data?.firmDto?.signature3Dto.signatureText == null
            ? ""
            : data.firmDto.signature3Dto.signatureText,
        isSignatureImageDeleted: data?.signature3Dto?.isSignatureImageDeleted ? 1 : 0
      },
      contact1: {
        name:
          data.firmDto.contact1.name == null ? "" : data.firmDto.contact1.name,
        email:
          data.firmDto.contact1.email == null
            ? ""
            : data.firmDto.contact1.email,
        type:
          data.firmDto.contact1.type == null ? "" : data.firmDto.contact1.type,
        mobile:
          data.firmDto.contact1.mobile == null
            ? ""
            : data.firmDto.contact1.mobile,
        landline:
          data.firmDto.contact1.landline == null
            ? ""
            : data.firmDto.contact1.landline,
      },
      contact2: {
        name:
          data.firmDto.contact2.name == null ? "" : data.firmDto.contact2.name,
        email:
          data.firmDto.contact2.email == null
            ? ""
            : data.firmDto.contact2.email,
        type:
          data.firmDto.contact2.type == null ? "" : data.firmDto.contact2.type,
        mobile:
          data.firmDto.contact2.mobile == null
            ? ""
            : data.firmDto.contact2.mobile,
        landline:
          data.firmDto.contact2.landline == null
            ? ""
            : data.firmDto.contact2.landline,
      },
      contact3: {
        name:
          data.firmDto.contact3.name == null ? "" : data.firmDto.contact3.name,
        email:
          data.firmDto.contact3.email == null
            ? ""
            : data.firmDto.contact3.email,
        type:
          data.firmDto.contact3.type == null ? "" : data.firmDto.contact3.type,
        mobile:
          data.firmDto.contact3.mobile == null
            ? ""
            : data.firmDto.contact3.mobile,
        landline:
          data.firmDto.contact3.landline == null
            ? ""
            : data.firmDto.contact3.landline,
      },
      // headerFile: null,
      // footerFile: null,
      // signatureFile2: null,
      // signatureFile3: null,
      reqBlankLines: data.firmDto.reqBlankLines,
      reqBlankLinesAfterHeader:data.firmDto.reqBlankLinesAfterHeader,
      headerTextLine1: data.firmDto.headerTextLine1,
      headerTextLine2: data.firmDto.headerTextLine2,
      externalFirm: data?.firmDto?.externalFirm === 1,
      addPrintDisclaimer:
        roles[0] === USERTYPES.SUPERVISOR ||
        parseInt(searchParams.get("type")) === 1
          ? data?.firmDto?.addPrintDisclaimer
          : editFirmResponse?.data.data.disclaimerDto.addPrintDisclaimer,
      printDisclaimerText:
        roles[0] === USERTYPES.SUPERVISOR ||
        parseInt(searchParams.get("type")) === 1
          ? data?.firmDto?.printDisclaimerText
          : editFirmResponse?.data.data.disclaimerDto.printDisclaimerText,
      firmEmailNotify: data?.firmDto?.firmEmailNotify ?? false,
      firmWhatsappNotify: data?.firmDto?.firmWhatsappNotify ?? false,
      enableWhatsApp: !!data?.firmDto?.enableWhatsApp,       
      whatsappNumber: data?.firmDto?.whatsappNumber ?? "", 
      enableEmail: data?.firmDto?.enableEmail ?? true,
      notificationEmail: data?.firmDto?.notificationEmail ?? "",
      allowFirmAdminSetClientComm: data?.firmDto?.allowFirmAdminSetClientComm ?? false,
      firmAdminCanEnableWhatsapp: data?.firmDto?.firmAdminCanEnableWhatsapp ?? false,
      firmAdminCanEnableEmail: data?.firmDto?.firmAdminCanEnableEmail ?? false,
      addendumDisclaimerEnabled: data?.firmDto?.addendumDisclaimerEnabled,
      addendumDisclaimerText: data?.firmDto?.addendumDisclaimerText,
      studyLinkExpiryTime: data?.firmDto?.studyLinkExpiryTime,
      qrLinkExpiryTime:
        data?.firmDto?.qrLinkExpiryTime ??
        editFirmResponse?.data?.data?.reportSettingDto?.qrLinkExpiryTime,
      enableShareReportLink: data?.firmDto?.enableShareReportLink,
      reportLinkExpiryTime: data?.firmDto?.reportLinkExpiryTime,
      reportLeftMarginPt: data?.firmDto?.reportLeftMarginPt,
      reportRightMarginPt: data?.firmDto?.reportRightMarginPt,
      accountWarning: data.accountWarningMessage,
      priorityCount: data.priorityStudyCount,
      branchCode: editFirmResponse?.data.data.configureSettingDto?.branchCode ? editFirmResponse?.data.data.configureSettingDto?.branchCode : data.configureSettingDto?.branchCode,
      showWord: editFirmResponse?.data.data.configureSettingDto?.showWord ? editFirmResponse?.data.data.configureSettingDto?.showWord : data.configureSettingDto?.showWord,
      selectedSubModalityListNumber: editFirmResponse?.data.data.configureSettingDto?.selectedSubModalityListNumber ? editFirmResponse?.data.data.configureSettingDto?.selectedSubModalityListNumber : data.configureSettingDto?.selectedSubModalityListNumber,
      updatedTimeString: null,
      schemeCode: null,
      autoAssignModalityWithSubModalityIds:
        editFirmResponse?.data.data.autoAssignEnableDto
          .modalityWithSubModalityIds == null
          ? []
          : editFirmResponse?.data.data.autoAssignEnableDto
              .modalityWithSubModalityIds,
      autoAssignModalityIds:
        editFirmResponse?.data.data.autoAssignEnableDto.modalityIds == null
          ? []
          : editFirmResponse?.data.data.autoAssignEnableDto.modalityIds.filter(
              (m) => m != null && m != ""
            ),
      autoAssignEnable:
        editFirmResponse?.data.data.autoAssignEnableDto.autoAssignEnabled,
      exactMatchEnable:
        editFirmResponse?.data.data.autoAssignEnableDto.exactMatchEnabled,
      pediatricAssignmentEnabled:
        editFirmResponse?.data.data.autoAssignEnableDto
          .pediatricAssignmentEnabled,
      selectedPediatricModalityId:
        editFirmResponse?.data.data.autoAssignEnableDto
          .selectedPediatricModalityId == null
          ? []
          : editFirmResponse?.data.data.autoAssignEnableDto.selectedPediatricModalityId.filter(
              (m) => m != null && m != ""
            ),
      isClientWarning: ownFirm
        ? data.isClientWarning
        : data.firmDto.isClientWarning,
      techinicianList: data.userList1,
      doctorList: data.userList2,
      allowDownloadStudy: data?.firmDto?.allowDownloadStudy,
      allowDownloadReport: data?.firmDto?.allowDownloadReport,
      enableQRCodeInReport: data?.firmDto?.enableQRCodeInReport,
      enableStudySharingLinkInReport: data?.firmDto?.enableStudySharingLinkInReport,
      emailPDF: data?.firmDto?.emailPDF ?? false,
      emailDOCX: data?.firmDto?.emailDOCX ?? false,
      emailDOC: data?.firmDto?.emailDOC ?? false,
      enableUnassignmentService: data?.firmDto?.enableUnassignmentService,
      firmEnableUnassignmentService: editFirmResponse?.data.data.unassignmentServiceDto.firmEnableUnassignmentService,
      unassignmentModalityIds: (editFirmResponse?.data.data.unassignmentServiceDto.unassignmentModalityIds && Array.isArray(editFirmResponse?.data.data.unassignmentServiceDto.unassignmentModalityIds)) 
    ? editFirmResponse?.data.data.unassignmentServiceDto.unassignmentModalityIds.filter(m => m != null) 
    : [],
      historyAvailable:
        editFirmResponse?.data.data.historyAvailableDto.historyAvailable,
      historyModalityIds:
        editFirmResponse?.data.data.historyAvailableDto.modalityIds == null
          ? []
          : editFirmResponse?.data.data.historyAvailableDto.modalityIds.filter(
              (m) => m != null && m != ""
          ),
      clinicalNoteMandatory: editFirmResponse?.data.data.historyAvailableDto.clinicalNoteMandatory,
      subModalityMandatory: editFirmResponse?.data.data.historyAvailableDto.subModalityMandatory,
      technicianContactMandatory: editFirmResponse?.data.data.historyAvailableDto.technicianContactMandatory,
      radiologistIdList:
        roles[0] === USERTYPES.FIRMADMIN &&
        !ownFirm &&
        parseInt(searchParams.get("type")) === 0
          ? prepareRadiologistList(
              editFirmResponse?.data.data.connectedUsersResponseDto.userList,
              editFirmResponse?.data.data.connectedUsersResponseDto.userchklist
            )
          : [],
      supervisorIdList:
        roles[0] === USERTYPES.FIRMADMIN &&
        !ownFirm &&
        parseInt(searchParams.get("type")) === 0
          ? prepareSupervisorList(
              editFirmResponse?.data.data.connectedUsersResponseDto
                .supervisorList,
              editFirmResponse?.data.data.connectedUsersResponseDto
                .supervisorChkList
            )
          : [],
      firmIdList: data?.hospitalchklist?.map((hid) => "" + hid),
      showPriorsStudies: (roles[0] === USERTYPES.ADMIN || (roles[0] === USERTYPES.FIRMADMIN && ownFirm)) ? data.firmDto?.showPriorsStudies : editFirmResponse?.data.data.disclaimerDto.showPriorsStudies,
      enableSecondaryCapture: (roles[0] === USERTYPES.FIRMADMIN && ownFirm) ? data.firmDto?.enableSecondaryCapture : editFirmResponse?.data.data.firmSettingsDto.enableSecondaryCapture,
      enableGenkiStudyInference: (roles[0] === USERTYPES.FIRMADMIN && ownFirm) ? data.firmDto?.enableGenkiStudyInference : editFirmResponse?.data.data.firmSettingsDto.enableGenkiStudyInference,
      multiframeSplit:
        editFirmResponse?.data.data.firmSettingsDto?.multiframeSplit
        ?? data?.firmDto?.multiframeSplit
        ?? true,
      enableQualityModel: (roles[0] === USERTYPES.FIRMADMIN && ownFirm) ? data.firmDto?.enableQualityModel : editFirmResponse?.data.data.firmSettingsDto.enableQualityModel,
      compressStudyDownload: ((roles[0] === USERTYPES.FIRMADMIN && ownFirm) ? data.firmDto?.compressStudyDownload : editFirmResponse?.data.data.firmSettingsDto?.compressStudyDownload) ?? false,
      demoFirm: editFirmResponse?.data.data.disclaimerDto?.demoFirm ?? data?.firmDto?.demoFirm ?? false,
      demoExpiryType: (() => {
        const raw = editFirmResponse?.data.data.disclaimerDto?.demoExpiryType ?? data?.firmDto?.demoExpiryType ?? null;
        if (raw) return raw;
        const hasDate = !!(editFirmResponse?.data.data.disclaimerDto?.demoExpiryDate ?? data?.firmDto?.demoExpiryDate);
        const hasUploads = (editFirmResponse?.data.data.disclaimerDto?.maxStudyUploads ?? data?.firmDto?.maxStudyUploads) > 0;
        if (hasDate) return "date";
        if (hasUploads) return "uploads";
        return null;
      })(),
      demoExpiryDate: (() => {
        const raw = editFirmResponse?.data.data.disclaimerDto?.demoExpiryDate ?? data?.firmDto?.demoExpiryDate ?? null;
        if (!raw) return null;
        if (typeof raw === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(raw)) {
          const parts = raw.split('-');
          return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
        }
        return new Date(raw);
      })(),
      maxStudyUploads: editFirmResponse?.data.data.disclaimerDto?.maxStudyUploads ?? data?.firmDto?.maxStudyUploads ?? null,
      demoStudyCount: editFirmResponse?.data.data.disclaimerDto?.demoStudyCount ?? data?.firmDto?.demoStudyCount ?? null,
      showPrirosStudiesList: data?.showPriorsConnectionDto,
      cxrVersionViewer: data?.firmDto?.cxrVersionViewer,
      cxrVersionStudyList: data?.firmDto?.cxrVersionStudyList,
      boneEnabled: data?.firmDto?.boneEnabled,
      watermarkImageUrl: data?.firmDto?.watermarkImageUrl ?? null,
      isWatermarkImageDeleted: data?.firmDto?.isWatermarkImageDeleted ?? 0,
      watermarkOpacity: data?.firmDto?.watermarkOpacity ?? 100,
      watermarkWidth: data?.firmDto?.watermarkWidth ?? 100 ,
      watermarkRotation: data?.firmDto?.watermarkRotation ?? 0,
      showProbability: data?.firmDto?.showProbability,
      showFindings: data?.firmDto?.showFindings,
      cxrTriageMinAge: data?.firmDto?.cxrTriageMinAge ?? null,
      subtleFindings: data?.firmDto?.subtleFindings,
      showAboveThresholdScore: data?.firmDto?.showAboveThresholdScore,
      modalityBuckets: modalityBuckets,
      sendReportSubmitNotification: data?.firmDto?.sendReportSubmitNotification ?? 0,
      enableCriticalAlert: data?.firmDto?.enableCriticalAlert ?? true,
      firmTimeZone: data?.firmDto?.firmTimeZone ,
      addendumWorkflowEnabled: data?.firmDto?.addendumWorkflowEnabled ?? false,
      showAiResultsSavedReportForFirmDoctors:data?.firmDto?.showAiResultsSavedReportForFirmDoctors ?? false,
    });
    handleRegion(
      data?.firmDto?.country,
      data?.firmDto?.state,
      data?.firmDto?.city
    );
     setSelectedHeaderTemplateId(data?.firmDto?.masterStudyReportId ?? null);
     
     // Track the current unassignment modality IDs to detect changes on save
     const currentUnassignmentModalityIds = (editFirmResponse?.data.data.unassignmentServiceDto.unassignmentModalityIds && Array.isArray(editFirmResponse?.data.data.unassignmentServiceDto.unassignmentModalityIds)) 
       ? editFirmResponse?.data.data.unassignmentServiceDto.unassignmentModalityIds.filter(m => m != null) 
       : [];
     setPreviousUnassignmentModalityIds(currentUnassignmentModalityIds);
  };
  
  const fetchBucketData = async () => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    const response = await getBucketDetails();
    if (
      response.status === 200 &&
      response.data.result === "SUCCESS") {
        setBucketList(response?.data?.data);
        setLoading(false);
        setLoaderRunning(false);
        ref.current.complete();
      } else {
        setLoading(false);
        setLoaderRunning(false);
        ref.current.complete();
        setShow(false);
      }
  }

  const fetchConfigurationDetails = async (currentValues = {}) => {
    const response = await getConfigurationDetails();
    if (response.status === 200 && response.data.result === "SUCCESS") {
      const config = response?.data?.data;
      if (config?.studyLinkExpiryTime && !currentValues.studyLinkExpiryTime) {
        setFieldValue("studyLinkExpiryTime", config.studyLinkExpiryTime);
      }
      if (config?.qrLinkExpiryTime && !currentValues.qrLinkExpiryTime) {
        setFieldValue("qrLinkExpiryTime", config.qrLinkExpiryTime);
      }
      if(config?.qrLinkExpiryMaxHours && !currentValues.qrLinkExpiryMaxHours){
        setFieldValue("qrLinkMaxExpiryDays ",Math.floor(config.qrLinkExpiryMaxHours/24)||90);
      }
    }
  };

  const fetchData = async () => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    const body = {
      firmId: searchParams.get("firmId")
        ? parseInt(searchParams.get("firmId"))
        : null,
      type: searchParams.get("type")
        ? parseInt(searchParams.get("type"))
        : null,
      viewWarningOnly: searchParams.get("viewWarningOnly")
        ? searchParams.get("viewWarningOnly") == "true"
        : false,
      paginationUserDto: {
        pageNumber: 0,
        pageSize: 5,
        sortField: "name",
        sortOrder: false,
      },
      paginationHospitalDto: {
        pageNumber: 0,
        pageSize: 5,
        sortField: "name",
        sortOrder: false,
      },
    };

    const response = await getHospitalDetails(body);
    let editFirmResponse = null;
    if (
      parseInt(searchParams.get("type")) === 0 &&
      !ownFirm &&
      roles[0] === USERTYPES.FIRMADMIN
    ) {
      editFirmResponse = await getFirmSettingDetails(
        searchParams.get("firmId"),
        searchParams.get("type")
      );
    }
    if (
      response.status === 200 &&
      response.data.result === "SUCCESS" &&
      (!ownFirm &&
      roles[0] === USERTYPES.FIRMADMIN &&
      parseInt(searchParams.get("type")) === 0
        ? editFirmResponse?.status === 200 &&
          editFirmResponse?.data.result === "SUCCESS"
        : true)
    ) {
            setEditFirmResponseState(editFirmResponse);
      setFirmDataState(response.data.data);
      setHospitalDetails(response.data.data.firmDto);
      setModalityList(
        editFirmResponse?.data.data.qcSettingsResponseDto.modalityList
      );
      setModalityWithSubModalityList(
        editFirmResponse?.data.data.qcSettingsResponseDto
          .modalityWithSubModalityList
      );
      setHistoryModalityList(
        editFirmResponse?.data.data.historyAvailableDto.modalityList
      );

      setClientId(editFirmResponse?.data.data.historyAvailableDto.clientId);
      setUserFirmId(editFirmResponse?.data.data.historyAvailableDto.firmId);

      if (parseInt(searchParams.get("type")) === 1) {
        setFirmListForProviders(response.data.data.firmList);
        setHospitalCheckList(
          response.data.data.hospitalchklist.map((id) => "" + id)
        );
      }

      var details = response.data.data.firmDto;
      if (
        response.data.data.userList1 != null ||
        response.data.data.userList1 != undefined
      ) {
        setHospitalUserList(response.data.data.userList1);
      }
      if (
        response.data.data.userList2 != null ||
        response.data.data.userList2 != undefined
      ) {
        setHospitalDoctorList(response.data.data.userList2);
      }
      const data = response.data.data;
      if(response.data.data.showPriorsConnectionDto != null || response.data.data.showPriorsConnectionDto != undefined) {
        setShowPriorsStudiesList(response.data.data.showPriorsConnectionDto);
      }

      await setValuesForFirm(data, editFirmResponse);

      await fetchConfigurationDetails({
        studyLinkExpiryTime: data?.firmDto?.studyLinkExpiryTime,
        qrLinkExpiryTime:
          data?.firmDto?.qrLinkExpiryTime ??
          editFirmResponse?.data?.data?.reportSettingDto?.qrLinkExpiryTime,
      });

      setIsMinimal(data?.firmDto?.isMinimalAccount == 1 ? true : false);
      if (roles[0] === USERTYPES.FIRMTECHNICIAN) {
        setFirmTechnicianOwnFirm(data.ownFirm);
      }
      setHeaderImageFileName(data?.firmDto?.reportHeaderDto.headerImageUrl);
      setFooterImageFileName(data?.firmDto?.reportHeaderDto.footerImageUrl);
      preSelectedAutoAssignModality(
        editFirmResponse?.data.data.autoAssignEnableDto
          .modalityWithSubModalityIds == null
          ? []
          : editFirmResponse?.data.data.autoAssignEnableDto
              .modalityWithSubModalityIds
      );
      setPacsNodeList(data?.firmDto?.pacsNodeList);
      setAvailablePacsList(editFirmResponse?.data?.data?.configurePacsDto?.availablePacsNodes);
      setSelectedPacsList(editFirmResponse?.data?.data?.configurePacsDto?.selectedPacsNodes);
      setBucketList(data?.configureSettingDto?.bucketDetailsList);
      setLoading(false);
      setLoaderRunning(false);
      ref.current.complete();
    } else {
      setLoading(false);
      setLoaderRunning(false);
      ref.current.complete();
      setShow(false);
    }
    // return values;
  };

  let data = InitialData(props.firmType, props.firmRole, roles[0], action,isVdcPlatform);

  useEffect(()=>{
      console.log("Available PACS list :", availablePacsList);
      console.log("Selected PACS list :", selectedPacsList);
  },[availablePacsList, selectedPacsList])

  useEffect(() => {
    if (action !== ACTIONS.ADD) {
      if (roles.length !== 0) fetchData();
    }else if(action === ACTIONS.ADD){
      if (roles.length !== 0) {
        fetchBucketData();
        fetchConfigurationDetails();
      }
    }
  }, [roles, action]);

  const handleShowFileError = (errors) => {
    let errorShown = false;
    console.log("--- Error ----",errors);
    errors.map((error)=>{
        switch(true){
          case ((error.fieldName == "headerFile" || error.fieldName == "footerFile"
          || error.fieldName == "signatureFile2" || error.fieldName == "signatureFile2"
          || error.fieldName == "cxrTriageMinAge"
         // || error.fieldName == "whatsappNumber" || error.fieldName == "notificationEmail" || error.fieldName == "general"
        ) && !errorShown):
            showToastv2(TOAST_TYPE.ERROR, error.defaultMessage);
            errorShown = true;
            break;
          default:
            break;
        }
    })
  }

  // const {
  //   formik,
  //   values,
  //   errors,
  //   touched,
  //   handleBlur,
  //   handleChange,
  //   handleSubmit,
  //   setValues,
  //   setFieldValue,  
  // } = useFormik({
  //   initialValues: data,
  //   // validationSchema: FirmSchema,
  //   onSubmit: async (values) => {
  //     if (submitClicked) {
  //       if (
  //         action === ACTIONS.EDIT &&
  //         roles[0] === USERTYPES.FIRMADMIN &&
  //         !ownFirm &&
  //         parseInt(searchParams.get("type")) == 0
  //       ) {
  //         setLoadingState("Submitting hospital details");
  //         setLoading(true);
  //         setLoaderRunning(true);
  //         ref.current.continuousStart();

  //         let EditFirmDto = adminFirmEditDataModal(
  //           values,
  //           clientId,
  //           userFirmId,
  //           formattedAutoAssignModality,
  //           selectedRadiologistMap,
  //           selectedSupervisorMap,
  //           selectedPacsList
  //         );
  //         const response = await editFirmSettings(EditFirmDto);

  //         if (response.status === 200 && response.data.result === "SUCCESS") {
  //           setSuccessToast(true);
  //           window.location.assign(response.data.data.data.setViewName);
  //           setLoading(false);
  //           setLoaderRunning(false);
  //           ref.current.complete();
  //         } else {
  //           setLoading(false);
  //           setLoaderRunning(false);
  //           ref.current.complete();
  //           let errors = response.data.data.errorFields;
  //           handleShowFileError(errors);
  //           let globalError = {};
  //           errors.map((e) => {
  //             globalError = { ...globalError, [e.fieldName]: e.defaultMessage };
  //           });
  //           setFirmGlobalErrorState(globalError);
  //           setLoading(false);
  //         }
  //       } else {
  //         setLoadingState("Submitting hospital details");
  //         setLoading(true);
  //         setLoaderRunning(true);
  //         ref.current.continuousStart();
  //         let firmDto = firmDataModal(
  //           values,
  //           state,
  //           roles[0],
  //           formattedAutoAssignModality,
  //           hospitalCheckList,
  //           pacsNodeList,
  //           showPriorsStudiesList
  //         );

  //         const response = await addHospital(
  //           action,
  //           firmDto,
  //           values.reportHeaderDto.headerImage,
  //           values.reportHeaderDto.footerImage,
  //           values.signature2Dto.signatureFile2,
  //           values.signature3Dto.signatureFile3
  //         );

  //         if (response.status === 200 && response.data.result === "SUCCESS") {
  //           tabStatusInitialValue.tab2Status = {
  //             value: "Completed",
  //             color: "green",
  //           };
  //           let warnings = response.data.data.warningFields;
  //           if(warnings && warnings.length > 0){
  //             setLoading(false);
  //             setLoaderRunning(false);
  //             warnings.map((e) => {
  //               showToastv2(
  //                 TOAST_TYPE.INFO,
  //                 e.defaultMessage
  //                 );
  //             });
  //             setTimeout(() => {
  //                 setSuccessToast(true);
  //                 window.location.assign(response.data.data.viewName);
  //                 ref.current.complete();
  //             }, 2000);
  //           } else {
  //             setSuccessToast(true);
  //             window.location.assign(response.data.data.viewName);
  //             setLoading(false);
  //             setLoaderRunning(false);
  //             ref.current.complete();
  //           }
  //         } else {
  //           if(response?.status === 429){
  //             setLoaderRunning(false);
  //             ref.current.complete();
  //             showToastv2(TOAST_TYPE.ERROR, response?.data?.message);
  //             return;
  //           }
  //           let errors = response.data.data.errorFields;
  //           handleShowFileError(errors);
  //           let globalError = {};
  //           errors.map((e) => {
  //             globalError = { ...globalError, [e.fieldName]: e.defaultMessage };
  //           });
  //           setFirmGlobalErrorState(globalError);
  //           setLoading(false);
  //           setLoaderRunning(false);
  //           ref.current.complete();
  //         }
  //       }
  //     }
  //   },
  // });

  const formik = useFormik({
  initialValues: data,
  // validationSchema: FirmSchema, // Uncomment if you're using Yup
  onSubmit: async (values) => {
    if (!submitClicked) return;

    setLoadingState("Submitting hospital details");
    setLoading(true);
    setLoaderRunning(true);
    ref.current.continuousStart();

    if (
      action === ACTIONS.EDIT &&
      roles[0] === USERTYPES.FIRMADMIN &&
      !ownFirm &&
      parseInt(searchParams.get("type")) == 0
    ) {
      values.masterStudyReportId = selectedHeaderTemplateId;
      let EditFirmDto = adminFirmEditDataModal(
        values,
        clientId,
        userFirmId,
        formattedAutoAssignModality,
        selectedRadiologistMap,
        selectedSupervisorMap,
        selectedPacsList
      );

      let response;

      if (props.firmMode === "projects") {
        response = await editProjectSettings(EditFirmDto);
      } else {
        const headerFile = values.reportHeaderDto?.headerImage instanceof File ? values.reportHeaderDto.headerImage : null;
        const footerFile = values.reportHeaderDto?.footerImage instanceof File ? values.reportHeaderDto.footerImage : null;
        const signatureFile2 = values.signature2Dto?.signatureFile2 instanceof File ? values.signature2Dto.signatureFile2 : null;
        const signatureFile3 = values.signature3Dto?.signatureFile3 instanceof File ? values.signature3Dto.signatureFile3 : null;
        const watermarkFile = values.watermarkImage instanceof File ? values.watermarkImage : null;
        response = await editFirmSettings(EditFirmDto, headerFile, footerFile, signatureFile2, signatureFile3, watermarkFile);
      }


      if (response.status === 200 && response.data.result === "SUCCESS") {
        setSuccessToast(true);
        window.location.assign(response.data.data.data.setViewName);
      } else {
        let errors = response.data.data.errorFields;
        handleShowFileError(errors);
        let globalError = {};
        errors.map((e) => {
          globalError = { ...globalError, [e.fieldName]: e.defaultMessage };
        });
        setFirmGlobalErrorState(globalError);

        // 1) Build form-level/global error map (existing behavior)

        // 2) Build contactChannel error object expected by ContactDetailsSection
        const contactChannel = {
          error: false,
          msg: "",
          notificationEmail: { error: false, msg: "" },
          whatsappNumber: { error: false, msg: "" }
        };

        errors.forEach((e) => {
          const fn = e.fieldName;
          const msg = e.defaultMessage || e.message || "Invalid";

          if (fn === "notificationEmail") {
            contactChannel.error = true;
            contactChannel.notificationEmail = { error: true, msg };
            // set Formik field error for notificationEmail so components relying on touched/errors show it
            if (formik && typeof formik.setFieldError === "function") {
              formik.setFieldError("notificationEmail", msg);
            }
          }

          if (fn === "whatsappNumber" || fn === "whatsapp") {
            contactChannel.error = true;
            contactChannel.whatsappNumber = { error: true, msg };
            if (formik && typeof formik.setFieldError === "function") {
              formik.setFieldError("whatsappNumber", msg);
            }
          }
        });

        // 3) Save the contactChannel in shared error state so ContactDetailsSection will display it
        if (typeof setErrorContactState === "function") {
          setErrorContactState((prev) => ({
            ...prev,
            contactChannel
          }));
        }

        // If you also want the tab icon to show red (you used this earlier), keep that update:
        if (contactChannel.error) {
          setErrorContactState((prev) => ({
            ...prev,
            tabStatusInitialValue: {
              ...prev?.tabStatusInitialValue,
              tab2Status: { value: "Info", color: "red" }
            }
          }));
        }
      }
    } else {
      values.masterStudyReportId = selectedHeaderTemplateId;

      let firmDto = firmDataModal(
        values,
        state,
        roles[0],
        formattedAutoAssignModality,
        hospitalCheckList,
        pacsNodeList,
        showPriorsStudiesList
      );

      let response;

      const watermarkFile = values.watermarkImage instanceof File ? values.watermarkImage : null;

      if (props.firmMode === "projects") {
        response = await addProject(
          action,
          firmDto,
          values.reportHeaderDto.headerImage,
          values.reportHeaderDto.footerImage,
          values.signature2Dto.signatureFile2,
          values.signature3Dto.signatureFile3,
          watermarkFile
        );
      } else {
        response = await addHospital(
          action,
          firmDto,
          values.reportHeaderDto.headerImage,
          values.reportHeaderDto.footerImage,
          values.signature2Dto.signatureFile2,
          values.signature3Dto.signatureFile3,
          watermarkFile
        );
      }


      if (response.status === 200 && response.data.result === "SUCCESS") {
        tabStatusInitialValue.tab2Status = {
          value: "Completed",
          color: "green",
        };

        let warnings = response.data.data.warningFields;
        if (warnings && warnings.length > 0) {
          warnings.map((e) => {
            showToastv2(TOAST_TYPE.INFO, e.defaultMessage);
          });

          setTimeout(() => {
            setSuccessToast(true);
            window.location.assign(response.data.data.viewName);
            ref.current.complete();
          }, 2000);
        } else {
          setSuccessToast(true);
          window.location.assign(response.data.data.viewName);
        }
      } else {
        if (response?.status === 429) {
          showToastv2(TOAST_TYPE.ERROR, response?.data?.message);
          ref.current.complete();
          return;
        }

        let errors = response.data.data.errorFields;
        handleShowFileError(errors);
        let globalError = {};
        errors.map((e) => {
          globalError = { ...globalError, [e.fieldName]: e.defaultMessage };
        });
        setFirmGlobalErrorState(globalError);

        // Build contactChannel error object expected by ContactDetailsSection
        const contactChannel = {
          error: false,
          msg: "",
          notificationEmail: { error: false, msg: "" },
          whatsappNumber: { error: false, msg: "" }
        };

        errors.forEach((e) => {
          const fn = e.fieldName;
          const msg = e.defaultMessage || e.message || "Invalid";

          if (fn === "notificationEmail" || fn === "notification_email") {
            contactChannel.error = true;
            contactChannel.notificationEmail = { error: true, msg };
            // set Formik field error for notificationEmail so components relying on touched/errors show it
            if (formik && typeof formik.setFieldError === "function") {
              formik.setFieldError("notificationEmail", msg);
            }
          }

          if (fn === "whatsappNumber" || fn === "whatsapp" || fn === "whatsapp_number") {
            contactChannel.error = true;
            contactChannel.whatsappNumber = { error: true, msg };
            if (formik && typeof formik.setFieldError === "function") {
              formik.setFieldError("whatsappNumber", msg);
            }
          }
        });

        // 3) Save the contactChannel in shared error state so ContactDetailsSection will display it
        if (typeof setErrorContactState === "function") {
          setErrorContactState((prev) => ({
            ...prev,
            contactChannel
          }));
        }

          if (contactChannel.error) {
          setErrorContactState((prev) => ({
            ...prev,
            tabStatusInitialValue: {
              ...prev?.tabStatusInitialValue,
              tab2Status: { value: "Info", color: "red" }
            }
          }));
          if (errors.some(e => ["demoFirm", "demoExpiryDate", "demoExpiryType", "maxStudyUploads", "demoStudyCount"].includes(e.fieldName))) {
          setErrorContactState((prev) => ({
            ...prev,
            tabStatusInitialValue: {
              ...prev?.tabStatusInitialValue,
              tab1Status: { value: "Info", color: "red" }
            }
          }));
        }
        }
      }
    }

    setLoading(false);
    setLoaderRunning(false);
    ref.current.complete();
  },
});

const {
  values,
  errors,
  touched,
  handleBlur,
  handleChange,
  handleSubmit,
  setValues,
  setFieldValue,
} = formik;


  const choiceGroupStyles = {
    label: {
      display: "inline",
    },
    flexContainer: {
      columnGap: "1em",
      display: "inline-flex",
      flexDirection: "row",
      flexWrap: "wrap",
    },
  };

  useEffect(() => {
    if (
      firmDataState != null &&
      (action == ACTIONS.EDIT || action === ACTIONS.VIEW)
    ) {
      setValuesForFirm(firmDataState, editFirmResponseState);
    }
  }, [action]);

  useEffect(() => {
    getBreadCrumbItems();
  }, [roles]);

  useEffect(() => {
    // console.log(state.firmDto);
    setSuccessToast(false);
    if (action == ACTIONS.EDIT || action == ACTIONS.VIEW) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.tabStatusInitialValue = editTabStatusInitialIcon;
        return newVal;
      });
      if (
        hospitalDetails?.reportHeaderDto?.headerImageUrl != "" &&
        hospitalDetails?.reportHeaderDto?.headerImageUrl != null
      ) {
        fetchImage(
          "headerImage",
          hospitalDetails.reportHeaderDto.headerImageUrl,
          APIs.GETHEADERIMAGE
        );
      }
      if (
        hospitalDetails?.reportHeaderDto?.footerImageUrl != "" &&
        hospitalDetails?.reportHeaderDto?.footerImageUrl != null
      ) {
        fetchImage(
          "footerImage",
          hospitalDetails.reportHeaderDto.footerImageUrl,
          APIs.GETFOOTERIMAGE
        );
      }
      if (
        hospitalDetails?.signature2Dto?.signatureImageUrl != "" &&
        hospitalDetails?.signature2Dto?.signatureImageUrl != null
      ) {
        fetchImage(
          "signature2Image",
          hospitalDetails.signature2Dto.signatureImageUrl,
          APIs.GETSIGNATUREIMAGE
        );
      }
      if (
        hospitalDetails?.signature3Dto?.signatureImageUrl != "" &&
        hospitalDetails?.signature3Dto?.signatureImageUrl != null
      ) {
        fetchImage(
          "signature3Image",
          hospitalDetails.signature3Dto.signatureImageUrl,
          APIs.GETSIGNATUREIMAGE
        );
      }
      if (
        hospitalDetails?.watermarkImageUrl != "" &&
        hospitalDetails?.watermarkImageUrl != null
      ) {
        fetchImage(
          "watermarkImage",
          hospitalDetails.watermarkImageUrl,
          APIs.GETWATERMARKIMAGE
        );
      }
    }
  }, [hospitalDetails]);

  const handleSubmitCustom = async() => {
    if (+(values.reportLeftMarginPt || 0) > 20 || +(values.reportRightMarginPt || 0) > 20) {
      showToastv2(TOAST_TYPE.ERROR, t("string-literals.report-margin-max"));
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.tabStatusInitialValue.tab4Status = {
          value: "Info",
          color: "red",
        };
        return newVal;
      });
      return;
    }
    if (!(roles[0] === USERTYPES.FIRMADMIN && !ownFirm)) {
      if (selectedCountry === "") values.country = "";
      else values.country = selectedCountry.label;
      if (selectedCity === "") values.city = "";
      else values.city = selectedCity.label;
      if (selectedState === "") values.state = "";
      else values.state = selectedState.label;
    }

    if (
      action === ACTIONS.EDIT &&
      roles[0] === USERTYPES.FIRMADMIN &&
      !ownFirm
    ) {
      let validateFLag = true;
    const channelsValid = validateChannels(values);

      if (!channelsValid) {
      validateFLag = false;

      // Turn Contact Details tab circle red (same as Firm Details)
      setErrorContactState((prev) => ({
        ...prev,
        tabStatusInitialValue: {
          ...prev?.tabStatusInitialValue,
          tab2Status: { value: "Info", color: "red" },
        },
      }));

      // stop submission so error messages appear immediately
      return;
    }
      let validateFlagForFirmAdmin = true;
      if (!validateConfigureSettings(values, action)) {
        validateFlagForFirmAdmin = false;
      }
      // if(!validateChannels(values)){
      //   validateFlagForFirmAdmin = false;
      // }
      if (!validateHospitalSettings(values, action)) {
        validateFlagForFirmAdmin = false;
      }
      if (!validateOtherSettings(values)) {
        validateFlagForFirmAdmin = false;
      }
      if (
        !validateAutoAssignmentSettings(values, selectedModalityAndSubModality)
      ) {
        validateFlagForFirmAdmin = false;
      }
      if (selectedRadiologistMap.size > 0 || selectedSupervisorMap.size > 0) {
        let allValuesAreNonEmpty = true;
        let noModalityRadiologistName = "";
        let noModalitySupervisorName = "";
        for (let [key, value] of selectedRadiologistMap) {
          if (value.length === 0 || value.some((value) => value === "")) {
            allValuesAreNonEmpty = false;
            noModalityRadiologistName = radiologistList.find(
              (obj) => obj.id == key
            ).username;
            break;
          }
        }

        for (let [key, value] of selectedSupervisorMap) {
          if (value.length === 0 || value.some((value) => value === "")) {
            allValuesAreNonEmpty = false;
            noModalitySupervisorName = supervisorList.find(
              (obj) => obj.id == key
            ).username;
            break;
          }
        }
        if (!allValuesAreNonEmpty) {
          validateFlagForFirmAdmin = false;
          if (noModalityRadiologistName != "") {
            setTabStatusInitialValue(() => {
              const newStatus = { ...tabStatusInitialValue };
              newStatus["tab11Status"] = { value: "Info", color: "red" };
              return newStatus;
            });
            setShowSelectModalityDialog(true);
            setNoSelectionErrorMessage(
              'Select atleast one modality for radiologist " ' +
                noModalityRadiologistName +
                ' "'
            );
          }
          if (noModalitySupervisorName != "") {
            setTabStatusInitialValue(() => {
              const newStatus = { ...tabStatusInitialValue };
              newStatus["tab12Status"] = { value: "Info", color: "red" };
              return newStatus;
            });
            setShowSelectModalityDialog(true);
            setNoSelectionErrorMessage(
              'Select atleast one modality for supervisor " ' +
                noModalitySupervisorName +
                ' "'
            );
          }
          return;
        }
      }

      if (values.demoFirm) {
        if (!values.demoExpiryType) {
          showToastv2(TOAST_TYPE.ERROR, "Select an expiry criteria type");
          validateFlagForFirmAdmin = false;
        } else if (values.demoExpiryType === "date") {
          if (!(values.demoExpiryDate instanceof Date && !isNaN(values.demoExpiryDate))) {
            showToastv2(TOAST_TYPE.ERROR, "Select Expiry date");
            validateFlagForFirmAdmin = false;
          }
        } else if (values.demoExpiryType === "uploads") {
          if (values.maxStudyUploads == null) {
            showToastv2(TOAST_TYPE.ERROR, "Select Max study Upload");
            validateFlagForFirmAdmin = false;
          } else if (isNaN(values.maxStudyUploads)) {
            showToastv2(TOAST_TYPE.ERROR, "Enter a valid value");
            validateFlagForFirmAdmin = false;
          } else if (values.maxStudyUploads <= 0) {
            showToastv2(TOAST_TYPE.ERROR, "0 and negative values are not allowed");
            validateFlagForFirmAdmin = false;
          } else if (values.maxStudyUploads > 99999) {
            showToastv2(TOAST_TYPE.ERROR, "Maximum study uploads cannot exceed 5 digits");
            validateFlagForFirmAdmin = false;
          }
        }
      }

      if (values.watermarkImage instanceof File) {
        const allowedWatermarkExtensions = [".JPEG", ".jpeg", ".PNG", ".png", ".JPG", ".jpg"];
        const fileExt = values.watermarkImage.name.substring(values.watermarkImage.name.lastIndexOf('.'));
        if (!allowedWatermarkExtensions.includes(fileExt)) {
          showToastv2(TOAST_TYPE.ERROR, "'Watermark image must be in JPEG,JPG or PNG format");
          validateFlagForFirmAdmin = false;
        }
      }

      if (validateFlagForFirmAdmin) {
        console.log("Submitting with masterStudyReportId:", values.masterStudyReportId);
        setSubmitClick(true);
        handleSubmit();
      }
      return;
    }

    let validateFLag = true;

    const channelsValid = validateChannels(values);

    if (!channelsValid) {
      validateFLag = false;

      // Turn Contact Details tab circle red (same as Firm Details)
      setErrorContactState((prev) => ({
        ...prev,
        tabStatusInitialValue: {
          ...prev?.tabStatusInitialValue,
          tab2Status: { value: "Info", color: "red" },
        },
      }));

      // stop submission so error messages appear immediately
      return;
    }

    if (!validateContact(values)) {
      validateFLag = false;
    }
    if (!validateHospitalDetails(values)) {
      validateFLag = false;
    }
    if (!validateHospitalSettings(values, action)) {
      validateFLag = false;
    }
    if (
      !validateAutoAssignmentSettings(values, selectedModalityAndSubModality)
    ) {
      validateFLag = false;
    }
    if (!validatePacsNode(pacsNodeList)) {
      validateFLag = false;
    }

    if (values.isMinimalAccount != 1 && !isCxrTriageMinAgeValid(values)) {
      showToastv2(
        TOAST_TYPE.ERROR,
        t("hospital.cxr-triage-min-age-range", {
          min: getCxrTriageModeMinAge(values),
          max: CXR_TRIAGE_MAX_AGE,
        }),
      );
      validateFLag = false;
    }

    if (values.demoFirm) {
      if (!values.demoExpiryType) {
        showToastv2(TOAST_TYPE.ERROR, "Select an expiry criteria type");
        validateFLag = false;
      } else if (values.demoExpiryType === "date") {
        if (!(values.demoExpiryDate instanceof Date && !isNaN(values.demoExpiryDate))) {
          showToastv2(TOAST_TYPE.ERROR, "Select Expiry date");
          validateFLag = false;
        }
      } else if (values.demoExpiryType === "uploads") {
        if (values.maxStudyUploads == null) {
          showToastv2(TOAST_TYPE.ERROR, "Select Max study Upload");
          validateFLag = false;
        } else if (isNaN(values.maxStudyUploads)) {
          showToastv2(TOAST_TYPE.ERROR, "Enter a valid value");
          validateFLag = false;
        } else if (values.maxStudyUploads <= 0) {
          showToastv2(TOAST_TYPE.ERROR, "0 and negative values are not allowed");
          validateFLag = false;
        } else if (values.maxStudyUploads > 99999) {
          showToastv2(TOAST_TYPE.ERROR, "Maximum study uploads cannot exceed 5 digits");
          validateFLag = false;
        }
      }
    }
    
    if (values.watermarkImage instanceof File) {
      const allowedWatermarkExtensions = [".JPEG", ".jpeg", ".PNG", ".png", ".JPG", ".jpg"];
      const fileExt = values.watermarkImage.name.substring(values.watermarkImage.name.lastIndexOf('.'));
      if (!allowedWatermarkExtensions.includes(fileExt)) {
        showToastv2(TOAST_TYPE.ERROR, "'Watermark image must be in JPEG,JPG or PNG format");
        validateFLag = false;
      }
    }
    
    if (validateFLag == true) {
      setSubmitClick(true);
      handleSubmit();
    }
  };

  const handleProjectSubmitCustom = () => {
   
    let validateFLag = true;

    if (!validateProjectsDetails(values)) {
      validateFLag = false;
    }
    
    if (validateFLag == true) {
      setSubmitClick(true);
      handleSubmit();
    }
  };

  useEffect(() => {
    if (!showSelectModalityDialog) setNoSelectionErrorMessage("");
  }, [showSelectModalityDialog]);

  const handleClearImage = (imageType) => {
    if (imageType === 'header') {
      console.log("In headerImageType");
      setHeaderImageFileName(null);
      setIsHeaderFileDeleted(true);
      setValues({
        ...values,
        reportHeaderDto: {
          ...values.reportHeaderDto,
          isHeaderImageDeleted: 1,
          headerImageUrl: null,
          headerImage: null,
        }
      })
    }
    if (imageType === 'footer') {
      console.log("In footerImageType");
      setFooterImageFileName(null);
      setIsFooterFileDeleted(true);
      setValues({
        ...values,
        reportHeaderDto: {
              ...values.reportHeaderDto,
         footerImageUrl: null,
          footerImage: null,
         isFooterImageDeleted: 1
            }
      })
    }

    if (imageType === 'signature2') {
      console.log("In signatureFile2");
      setIsSignatureFile2Deleted(true);
      setValues({
        ...values,
        signature2Dto: {
              ...values.signature2Dto,
       isSignatureImageDeleted: 1,
        signatureFile2 : null,
        signature2Text: "",
    signatureImageUrl: ""
            }
      })
    }

    if (imageType === 'signature3') {
      console.log("In signatureFile3");
      setIsSignatureFile3Deleted(true);
      setValues({
        ...values,
        signature3Dto: {
          ...values.signature3Dto,
          isSignatureImageDeleted: 1,
        signatureFile3 : null,
        signature2Text: "",
    signatureImageUrl: ""
            }
      })
    }
    if (imageType === 'watermark') {
      setWatermarkImageValue("");
      setValues({
        ...values,
        watermarkImage: null,
        watermarkImageUrl: null,
        isWatermarkImageDeleted: 1,
        watermarkOpacity: 100,
        watermarkWidth: 100,
        watermarkRotation: 0,
      });
    }
  }

  const handleCancel = async () => {
    if (action === ACTIONS.ADD) {
      if(props.firmMode === "projects"){
        navigate(AuthRoutes.PROJECTLIST);
      }else{
        navigate(AuthRoutes.CLIENTLIST);
      }
    } else if (action === ACTIONS.EDIT) {

      setSelectedModalityAndSubModality([]);
      setSelectedRadiologistMap(new Map());
      setSelectedSupervisorMap(new Map());
      setSelectedPacsList([]);
      setCheckAllRadiologist(false);
      setCheckAllSupervisor(false);
      setCheckAllPacs(false);
      setSelectedPediatricModalityId([]);
      setAction(ACTIONS.VIEW);
      setBreadCrumBItems(
        viewBreadCrumbItems(
          state,
          enterprise,
          ownFirm,
          roles[0],
          window.location,
          viewWarningOnly,
          parseInt(searchParams.get("type")),
          props.firmMode
        )
      );
      // await fetchData();
      if(props.firmMode === "projects"){
        navigate(
          AuthRoutes.PROJECTDETAILS +
            "?firmId=" +
            parseInt(searchParams.get("firmId")) +
            "&type=" +
            parseInt(searchParams.get("type"))
        );
      }else{
        navigate(
          AuthRoutes.FIRMDETAILS +
            "?firmId=" +
            parseInt(searchParams.get("firmId")) +
            "&type=" +
            parseInt(searchParams.get("type"))
        );
      }
    }
  };

  const validateTabs = (tabNo) => {
    setSubmitClick(false);
    setSelectedValue(tabNo);
    if (action === ACTIONS.VIEW) return;

    if (
      action === ACTIONS.EDIT &&
      roles[0] === USERTYPES.FIRMADMIN &&
      !ownFirm
    ) {
      tabNo === "3" && validateConfigureSettings(values, action);
      tabNo === "4" && validateOtherSettings(values);
      tabNo === "7" &&
        validateAutoAssignmentSettings(values, selectedModalityAndSubModality);
      return;
    }
    tabNo === "1" && validateFirstTab();
    tabNo === "2" && validateSecondTab();
    tabNo === "3" && validateThirdTab();
    tabNo === "4" && validateForthTab();
    tabNo === "5" && validateHospitalSettings(values, action);
    tabNo === "6" && validateFifthTab();
  };

  const validateFirstTab = () => {
    if (action === ACTIONS.EDIT && roles[0] === USERTYPES.FIRMADMIN) return;
    return validateHospitalDetails(values);
  };

  const validateSecondTab = () => {
    if (action === ACTIONS.EDIT && roles[0] === USERTYPES.FIRMADMIN) return;
    return validateContact(values);
  };

  const validateThirdTab = () => {
    setErrorContactState(() => {
      const newVal = { ...errorContactState };
      newVal.tabStatusInitialValue.tab3Status = {
        value: "Completed",
        color: "green",
      };
      return newVal;
    });
    return true;
  };

  const validateForthTab = () => {
    if (+(values.reportLeftMarginPt || 0) > 20 || +(values.reportRightMarginPt || 0) > 20) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.tabStatusInitialValue.tab4Status = {
          value: "Info",
          color: "red",
        };
        return newVal;
      });
      showToastv2(TOAST_TYPE.ERROR, t("string-literals.report-margin-max"));
      return false;
    }
    setErrorContactState(() => {
      const newVal = { ...errorContactState };
      newVal.tabStatusInitialValue.tab4Status = {
        value: "Completed",
        color: "green",
      };
      return newVal;
    });
    return true;
  };

  const validateFifthTab = () => {
    return validateHospitalSettings(values, action);
  };

  const handleRegion = (varCountry, varState, varCity) => {
    const country =
      varCountry === "Undefined"
        ? undefined
        : Country.getAllCountries().filter(
            (country) => country.name === varCountry
          )[0];

    let state;
    if (country != undefined) {
      state =
        varState === "Undefined"
          ? undefined
          : State.getStatesOfCountry(country.isoCode).filter(
              (state) => state.name === varState
            )[0];
    }
    let city;
    if (state != undefined) {
      city =
        varCity === "Undefined"
          ? undefined
          : City.getCitiesOfState(country.isoCode, state.isoCode).filter(
              (city) => city.name === varCity
            )[0];
    }

    if (country !== undefined) {
      setSelectedCountry({
        value: country.isoCode,
        label: country.name,
      });
    }
    if (state !== undefined) {
      setSelectedState({
        value: state.isoCode,
        label: state.name,
      });
    }
    if (city !== undefined) {
      setSelectedCity({
        value: city.name,
        label: city.name,
      });
    }
  };

  const handleEdit = () => {
    handleRegion(values.country, values.state, values.city);
    if (ownFirm) {
      setAction(ACTIONS.EDIT);
      setBreadCrumBItems(
        editBreadCrumbItems(
          state,
          enterprise,
          ownFirm,
          roles[0],
          parseInt(searchParams.get("type")),
          props.firmMode
        )
      );
      navigate(AuthRoutes.EDITHOSPITAL, {
        state: {
          firmDto: hospitalDetails,
          action: ACTIONS.EDIT,
          type: firmType,
          id: currFirmId,
        },
      });
    } else {
      setAction(ACTIONS.EDIT);
      setBreadCrumBItems(
        editBreadCrumbItems(
          state,
          enterprise,
          ownFirm,
          roles[0],
          parseInt(searchParams.get("type")),
          props.firmMode
        )
      );
      if(props.firmMode === "projects"){
        navigate(
          AuthRoutes.EDITPROJECT +
            "?firmId=" +
            parseInt(searchParams.get("firmId")) +
            "&type=" +
            parseInt(searchParams.get("type")),
          {
            state: {
              firmDto: hospitalDetails,
              action: ACTIONS.EDIT,
              type: firmType,
              id: currFirmId,
            },
          }
        );
      }else{
        navigate(
          AuthRoutes.EDITHOSPITAL +
            "?firmId=" +
            parseInt(searchParams.get("firmId")) +
            "&type=" +
            parseInt(searchParams.get("type")),
          {
            state: {
              firmDto: hospitalDetails,
              action: ACTIONS.EDIT,
              type: firmType,
              id: currFirmId,
            },
          }
        );
      }
      // fetchData()
    }
  };

  const handleEditConfiguration = () => {
    setSelectedValue(6);
    setEditConfigurationSetting(true);
    // state = {action:ACTIONS.EDIT};
    setAction(ACTIONS.EDIT);
  };

  // Admin / Firm Admin / Firm Tech with report-config flag
  const canPreviewSampleReport =
    !values?.isClientWarning &&
    (roles[0] === USERTYPES.ADMIN ||
      roles[0] === USERTYPES.FIRMADMIN ||
      (roles[0] === USERTYPES.FIRMTECHNICIAN &&
        enableReportAndHeaderTemplateConfigurations));

  // Live Formik + unsaved images → PDF (no firm save)
  const handlePreviewSampleReport = async () => {
    try {
      setLoadingState(t("hospital.preview-sample-report") || "Preview Sample Report");
      setLoading(true);
      setLoaderRunning(true);
      ref.current?.continuousStart?.();

      const previewValues = {
        ...formik.values,
        masterStudyReportId:
          selectedHeaderTemplateId ?? formik.values.masterStudyReportId,
      };

      const previewClientId =
        clientId ||
        currFirmId ||
        previewValues?.id ||
        searchParams.get("firmId") ||
        null;

      const dto = buildSampleReportPreviewDto(
        previewValues,
        previewClientId && previewClientId !== 0 ? previewClientId : null,
        userFirmId || firmId || null
      );

      const headerFile =
        previewValues.reportHeaderDto?.headerImage instanceof File
          ? previewValues.reportHeaderDto.headerImage
          : null;
      const footerFile =
        previewValues.reportHeaderDto?.footerImage instanceof File
          ? previewValues.reportHeaderDto.footerImage
          : null;
      const signatureFile2 =
        previewValues.signature2Dto?.signatureFile2 instanceof File
          ? previewValues.signature2Dto.signatureFile2
          : null;
      const signatureFile3 =
        previewValues.signature3Dto?.signatureFile3 instanceof File
          ? previewValues.signature3Dto.signatureFile3
          : null;
      const watermarkFile =
        previewValues.watermarkImage instanceof File
          ? previewValues.watermarkImage
          : null;

      const response = await previewSampleReport(
        dto,
        headerFile,
        footerFile,
        signatureFile2,
        signatureFile3,
        watermarkFile
      );

      if (response?.status === 200 && response?.data?.result === "SUCCESS") {
        showToastv2(
          TOAST_TYPE.SUCCESS,
          t("hospital.preview-sample-report-success") ||
            "Sample report preview opened"
        );
      } else {
        showToastv2(
          TOAST_TYPE.ERROR,
          response?.data?.message ||
            t("hospital.preview-sample-report-failed") ||
            "Failed to generate sample report preview"
        );
      }
    } catch (error) {
      showToastv2(
        TOAST_TYPE.ERROR,
        error?.message ||
          t("hospital.preview-sample-report-failed") ||
          "Failed to generate sample report preview"
      );
    } finally {
      setLoading(false);
      setLoaderRunning(false);
      ref.current?.complete?.();
    }
  };

const handleSaveConfiguration = async () => {
    let dataMap = {
        clientAccessDto: {
            firmId: firmId,
            clientId: currFirmId,
            radiologistIdList: values.radiologistIdList || [],
            supervisorIdList: values.supervisorIdList || []
        },
        qcSettingDto: {
            firmId: firmId,
            clientId: currFirmId,
            qcEnabled: values.qcEnabled ? 1 : 0,
            preliminaryQcEnabled: values.preliminaryQcEnabled ? 1 : 0,
            twoSignaturesAllowed: values.twoSignaturesAllowed ? 1 : 0,
            enableQCAutoAssignment: values.enableQCAutoAssignment ? 1 : 0,
            modalityIds: values.modalityIds,
        },
        unassignmentServiceDto: {
            firmId: firmId,
            clientId: currFirmId,
            firmEnableUnassignmentService: values.firmEnableUnassignmentService,
            unassignmentModalityIds: (values.unassignmentModalityIds && Array.isArray(values.unassignmentModalityIds)) 
        ? values.unassignmentModalityIds 
        : []
        },

        historyAvailableDto: {
            firmId: firmId,
            clientId: currFirmId,
            historyAvailable: values.historyAvailable,
            clinicalNoteMandatory: values.clinicalNoteMandatory,
            subModalityMandatory: values.subModalityMandatory,
            technicianContactMandatory: values.technicianContactMandatory,
        },
        autoAssignEnableDto: {
            firmId: firmId,
            clientId: currFirmId,
            autoAssignEnabled: values.autoAssignEnable ? 1 : 0,
            modalityIds: values.autoAssignModalityIds,
            modalityWithSubModalityIds: formattedAutoAssignModality(),
            exactMatchEnabled: values.exactMatchEnable,
            pediatricAssignmentEnabled: values.pediatricAssignmentEnabled ? 1 : 0,
            selectedPediatricModalityId: values.selectedPediatricModalityId,
        },
        disclaimerDto: {
            firmId: firmId,
            clientId: currFirmId,
            addPrintDisclaimer: values.addPrintDisclaimer ? 1 : 0,
            printDisclaimerText: values.printDisclaimerText,
          addendumDisclaimerEnabled: values.addendumDisclaimerEnabled ? 1 : 0,
          addendumDisclaimerText: values.addendumDisclaimerText ?? "",
            accountWarning: values.accountWarning,
            showPriorsStudies: values.showPriorsStudies,
            demoFirm: !!values.demoFirm,
            demoExpiryDate: values.demoExpiryDate instanceof Date && !isNaN(values.demoExpiryDate)
              ? `${values.demoExpiryDate.getFullYear()}-${String(values.demoExpiryDate.getMonth() + 1).padStart(2, '0')}-${String(values.demoExpiryDate.getDate()).padStart(2, '0')}`
              : (values.demoExpiryDate ?? null),
            maxStudyUploads: values.maxStudyUploads ?? null
        },
        reportSettingDto: {
          firmId: firmId,
          clientId: currFirmId,
          addendumDisclaimerEnabled: values.addendumDisclaimerEnabled ? 1 : 0,
          addendumDisclaimerText: values.addendumDisclaimerText ?? "",
          enableStudySharingLinkInReport: values.enableStudySharingLinkInReport,
          emailPDF: values.emailPDF ? 1 : 0,
          emailDOCX: values.emailDOCX ? 1 : 0,
          emailDOC: values.emailDOC ? 1 : 0,
        },
        
        firmSettingsDto: {
            enableSecondaryCapture: values.enableSecondaryCapture,
            enableGenkiStudyInference: values.enableGenkiStudyInference,
            multiframeSplit: values.multiframeSplit,
            enableQualityModel: values.enableQualityModel,  // Added for Quality flag model
            compressStudyDownload: values.compressStudyDownload ?? false
        }
    };

    if (values.demoFirm) {
      if (!values.demoExpiryType) {
        showToastv2(TOAST_TYPE.ERROR, "Select an expiry criteria type");
        setLoading(false);
        setLoaderRunning(false);
        ref.current?.complete();
        return;
      }
      if (values.demoExpiryType === "date") {
        if (!(values.demoExpiryDate instanceof Date && !isNaN(values.demoExpiryDate))) {
          showToastv2(TOAST_TYPE.ERROR, "Select Expiry date");
          setLoading(false);
          setLoaderRunning(false);
          ref.current?.complete();
          return;
        }
      } else if (values.demoExpiryType === "uploads") {
        if (values.maxStudyUploads == null) {
          showToastv2(TOAST_TYPE.ERROR, "Select Max study Upload");
          setLoading(false);
          setLoaderRunning(false);
          ref.current?.complete();
          return;
        }
        if (isNaN(values.maxStudyUploads)) {
          showToastv2(TOAST_TYPE.ERROR, "Enter a valid value");
          setLoading(false);
          setLoaderRunning(false);
          ref.current?.complete();
          return;
        }
        if (values.maxStudyUploads <= 0) {
          showToastv2(TOAST_TYPE.ERROR, "0 and negative values are not allowed");
          setLoading(false);
          setLoaderRunning(false);
          ref.current?.complete();
          return;
        }
        if (values.maxStudyUploads > 99999) {
          showToastv2(TOAST_TYPE.ERROR, "Maximum study uploads cannot exceed 5 digits");
          setLoading(false);
          setLoaderRunning(false);
          ref.current?.complete();
          return;
        }
      }
    }

    if (values.watermarkImage instanceof File) {
      const allowedWatermarkExtensions = [".JPEG", ".jpeg", ".PNG", ".png", ".JPG", ".jpg"];
      const fileExt = values.watermarkImage.name.substring(values.watermarkImage.name.lastIndexOf('.'));
      if (!allowedWatermarkExtensions.includes(fileExt)) {
        showToastv2(TOAST_TYPE.ERROR, "'Watermark image must be in JPEG,JPG or PNG format'");
        setLoading(false);
        setLoaderRunning(false);
        ref.current?.complete();
        return;
      }
    }

    setLoadingState("Saving firm settings");
    setLoading(true);
    setLoaderRunning(true);
    ref.current?.continuousStart();

    try {
      const response = await saveFirmSettingDetails(dataMap);

      if (response?.status === 200 && response?.data?.result === "SUCCESS") {
        // Check if unassignment modalities have changed and dispatch event
        const currentUnassignmentModalityIds = values.unassignmentModalityIds || [];
        const modalitiesChanged = JSON.stringify(previousUnassignmentModalityIds.sort()) !== JSON.stringify(currentUnassignmentModalityIds.sort());
        
        if (modalitiesChanged) {
          console.log("Unassignment modalities changed, dispatching event to reset timer.");
          eventBus.dispatch("firmConfigurationUpdated", {
            unassignmentModalitiesChanged: true,
          });
          setPreviousUnassignmentModalityIds(currentUnassignmentModalityIds);
        }
        
        setAction(ACTIONS.VIEW);
        setEditConfigurationSetting(false);
        showToastv2(TOAST_TYPE.SUCCESS, response?.data?.message || "Settings saved successfully");
      } else {
        const errorFields = response?.data?.data?.errorFields;
        const errorMsg = errorFields?.[0]?.defaultMessage || response?.data?.message || "Unable to save settings. Please try again.";
        showToastv2(TOAST_TYPE.ERROR, errorMsg);
      }
    } catch (error) {
      showToastv2(
        TOAST_TYPE.ERROR,
        error?.response?.data?.message || "Unable to save settings. Please try again."
      );
    } finally {
      setLoading(false);
      setLoaderRunning(false);
      ref.current?.complete();
    }
};

  const handleCloseConfiguartion = () => {
    setAction("VIEW");
    setEditConfigurationSetting(false);
    handleCancel();
  };

  const getBreadCrumbItems = () => {
    action == "EDIT"
      ? setBreadCrumBItems(
          editBreadCrumbItems(
            state,
            enterprise,
            ownFirm,
            roles[0],
            parseInt(searchParams.get("type")),
            props.firmMode
          )
        )
      : action == "ADD"
      ? setBreadCrumBItems(
          addbreadCrumbItems(
            state,
            enterprise,
            roles[0],
            parseInt(searchParams.get("type")),
            props.firmMode
          )
        )
      : setBreadCrumBItems(
          viewBreadCrumbItems(
            state,
            enterprise,
            ownFirm,
            roles[0],
            window.location,
            viewWarningOnly,
            parseInt(searchParams.get("type")),
            props.firmMode
          )
        );
  };

  let tabDetails = getFirmTabs(
    formik,
    handleCancel,
    setTotalTabs,
    roles,
    values,
    setFieldValue,
    errorContactState,
    t,
    ownFirm,
    handleChange,
    handleClearImage,
    setIsHeaderFileDeleted,
    isHeaderFileDeleted,
    setIsFooterFileDeleted,
    isFooterFileDeleted,
    setIsSignatureFile2Deleted,
    isSignatureFile2Deleted,
    setIsSignatureFile3Deleted,
    isSignatureFile3Deleted,
    setIsWatermarkImageDeleted,
    isWatermarkImageDeleted,
    
    handleBlur,
    errors,
    touched,
    state,
    action,
    editConfigurationSetting,
    choiceGroupStyles,
    headerImageValue,
    footerImageValue,
    watermarkImageValue,
    signature2ImageValue,
    signature3ImageValue,
    modalityList,
    modalityWithSubModalityList,
    selectedCountry,
    setSelectedCountry,
    selectedState,
    setSelectedState,
    selectedCity,
    setSelectedCity,
    historyModalityList,
    firmGlobalErrorState,
    viewWarningOnly,
    isMinimal,
    headerImageFileName,
    setHeaderImageFileName,
    footerImageFileName,
    setFooterImageFileName,
    selectedModalityAndSubModality,
    setSelectedModalityAndSubModality,
    parseInt(searchParams.get("type")),
    selectedRadiologistMap,
    setSelectedRadiologistMap,
    radiologistList,
    setRadiologistList,
    checkAllRadiologist,
    setCheckAllRadiologist,
    selectedSupervisorMap,
    setSelectedSupervisorMap,
    supervisorList,
    setSupervisorList,
    checkAllSupervisor,
    setCheckAllSupervisor,
    tabStatusInitialValue,
    setTabStatusInitialValue,
    firmListForProviders,
    hospitalCheckList,
    setHospitalCheckList,
    pacsNodeList,
    setPacsNodeList,
    availablePacsList, 
    setAvailablePacsList,
    checkAllPacs, 
    setCheckAllPacs,
    selectedPacsList, 
    setSelectedPacsList,
    showPriorsStudiesList, 
    setShowPriorsStudiesList,
    bucketList,
    props.firmMode,
    setErrorContactState,
    routeToNodeEnabled,
    validateContact,
    validateChannels,
    enableReportAndHeaderTemplateConfigurations,
    selectedHeaderTemplateId,                      
    setSelectedHeaderTemplateId
  );

  useEffect(() => {
    resetValues(action);
  }, [action]);

//   const headerTopButtons = [
//   {
//     key: "1",
//     button: (
//       <PrimaryButton
//         key="1"
//         style={{
//           marginLeft: "10px",
//           display:
//             roles[0] === USERTYPES.FIRMTECHNICIAN
//               ? 
//                 isMinimal && enableReportAndHeaderTemplateConfigurations
//                 ? "inline-block"
//                 : "none"
//               : 
//               roles[0] === USERTYPES.FIRMDOCTOR
//               ? "none"
//               : 
//               ((roles[0] === USERTYPES.ADMIN ||
//                   (roles[0] === USERTYPES.FIRMADMIN || ownFirm)) &&
//                   action === ACTIONS.EDIT) ||
//                 viewWarningOnly
//               ? "none"
//               : "inline-block",
//         }}
//         text={t("hospital.edit-header-template")}
//         onClick={() => {
//           if (roles[0] === USERTYPES.ADMIN) {
//             navigate(AuthRoutes.EDITHEADERTEMPLATE + "?firmId=" + values.id);
//           } else if (roles[0] === USERTYPES.FIRMADMIN) {
//             if (!ownFirm) {
//               navigate(AuthRoutes.EDITHEADERTEMPLATE + "?clientId=" + currFirmId);
//             } else {
//               navigate(AuthRoutes.EDITHEADERTEMPLATE);
//             }
//           }
//           else if (roles[0] === USERTYPES.FIRMTECHNICIAN) {
//           if (currFirmId) {
//             navigate(AuthRoutes.EDITHEADERTEMPLATE + "?clientId=" + currFirmId);
//           } else {
//             navigate(AuthRoutes.EDITHEADERTEMPLATE);
//           }
//         }
//           else {
//              if (currFirmId) {
//             navigate(AuthRoutes.EDITHEADERTEMPLATE + "?clientId=" + currFirmId);
//           } else {
//             navigate(AuthRoutes.EDITHEADERTEMPLATE);
//           }
//           }
//         }}
//       />
//     ),
//   },
// ];

  const topButtons = [
    !values?.isClientWarning && {
      key: "1",
      button: (
        <PrimaryButton
          key="1"
          style={{
            marginLeft: "10px",
            display:
              action === ACTIONS.EDIT ||
              roles[0] === USERTYPES.FIRMDOCTOR ||
              (roles[0] === USERTYPES.FIRMTECHNICIAN && !isMinimal)
                ? "none"
                : "inline-block",
          }}
          text={t("button.edit")}
          onClick={handleEdit}
        />
      ),
    },
    // roles[0] === USERTYPES.ADMIN && {
    //   key: "2",
    //   button: (
    //     <PrimaryButton
    //       key="1"
    //       style={{
    //         marginLeft: "10px",
    //         display:
    //           roles[0] === USERTYPES.ADMIN &&
    //           (action === ACTIONS.EDIT || isMinimal)
    //             ? "none"
    //             : "inline-block",
    //       }}
    //       text={t("hospital.firm-admin")}
    //       onClick={() =>
    //         navigate(AuthRoutes.FIRMADMINUSERLIST + "?firmId=" + values.id)
    //       }
    //     />
    //   ),
    // },
    // roles[0] === USERTYPES.ADMIN && {
    //   key: "3",
    //   button: (
    //     <PrimaryButton
    //       key="1"
    //       style={{
    //         marginLeft: "10px",
    //         display:
    //           roles[0] === USERTYPES.ADMIN &&
    //           (action === ACTIONS.EDIT || isMinimal)
    //             ? "none"
    //             : "inline-block",
    //       }}
    //       text={t("hospital.supervisor")}
    //       onClick={() =>
    //         navigate(AuthRoutes.SUPERVISORLIST + "?firmId=" + values.id)
    //       }
    //     />
    //   ),
    // },
  ];

  const ClientTopButtons = [
    !values?.isClientWarning && {
      key: "1",
      button: (
        <PrimaryButton
          key="1"
          style={{
            marginLeft: "10px",
            display:
              action === ACTIONS.EDIT || viewWarningOnly
                ? "none"
                : "inline-block",
          }}
          text={t("hospital.edit")}
          onClick={handleEdit}
        />
      ),
    },
    editConfigurationSetting && {
      key: "2",
      button: (
        <DefaultButton
          key="2"
          style={{ marginLeft: "10px" }}
          text={t("button.cancel")}
          onClick={handleCloseConfiguartion}
        />
      ),
    },
    editConfigurationSetting && {
      key: "3",
      button: (
        <PrimaryButton
          key="3"
          style={{ marginLeft: "10px" }}
          text={t("button.save")}
          onClick={handleSaveConfiguration}
        />
      ),
    },
  ];

  const saasTopButtons = () => {
    // roles[0] != USERTYPES.FIRMADMIN ? action == ACTIONS.VIEW ? topButtons : [] : action == ACTIONS.VIEW ? ClientTopButtons : []

    if (parseInt(searchParams.get("type")) === 1)
      return [
        {
          key: "1",
          button: (
            <PrimaryButton
              key="1"
              style={{
                marginLeft: "10px",
                display: action === ACTIONS.EDIT || viewWarningOnly ? "none" : "inline-block",
              }}
              text={t("hospital.edit")}
              onClick={handleEdit}
            />
          ),
        },
      ];

    if (roles[0] === USERTYPES.FIRMADMIN && action !== ACTIONS.ADD) {
      return ownFirm ? topButtons : ClientTopButtons;
    }
    if (
      (roles[0] === USERTYPES.ADMIN ||
        roles[0] === USERTYPES.FIRMTECHNICIAN ||
        roles[0] === USERTYPES.FIRMDOCTOR) &&
      action !== ACTIONS.ADD
    ) {
      return topButtons;
    }
    if (
      roles[0] === USERTYPES.RADIOLOGIST ||
      (roles[0] === USERTYPES.SUPERVISOR && action !== ACTIONS.ADD)
    ) {
      return [];
    }
    return [];
  };

  const tabValidation = (latestVal, previousVal) => {
    validateTabs(previousVal.charAt(previousVal.length - 1));
  };

  const previewSampleReportButton = canPreviewSampleReport ? (
    <DefaultButton
      style={{ marginLeft: "10px" }}
      text={t("hospital.preview-sample-report") || "Preview Sample Report"}
      onClick={handlePreviewSampleReport}
      disabled={loading}
    />
  ) : null;

  return (
    <>
      {" "}
      {authenticated && (
        <>
          {!show ? (
            <NotAllowed msg={t("string-literals.error-msg")} />
          ) : (
            <>
             
              {props.firmMode === "projects" ? (
                  <>
                  {(action === ACTIONS.ADD || action === ACTIONS.EDIT) && (
                    <>
                      <FormikProvider value={formik}>
                        <TabContainer
                          uniqueKey={"firm_"}
                          tabDetails={tabDetails}
                          NoOfTabs={tabDetails.length}
                          onCancelClick={handleCancel}
                          onSubmitClick={handleProjectSubmitCustom}
                          onNextClick={validateTabs}
                          onEditClick={handleEdit}
                          previousNextButton={true}
                          state={state}
                          action={action}
                          breadCrumbItems={breadCrumbItems}
                          sectionLeftButton={previewSampleReportButton}
                          topButtons={
                            enterprise
                              ? action == ACTIONS.VIEW
                                ? topButtons
                                : []
                              : saasTopButtons()
                          }
                          tabValidation={tabValidation}
                          defaultSelectedValue={viewWarningOnly ? tabDetails.length : 1}
                        />
                      </FormikProvider>
                      <DialogBox
                        setShowDialogBox={setShowSelectModalityDialog}
                        showDialogBox={showSelectModalityDialog}
                        title={t("user.alert")}
                        message={noSelectionErrorMessage}
                        confirmButtonText={t("user.ok")}
                      />
                    </>
                  )}

                  {action === ACTIONS.VIEW && (
                    <TabContainer
                      uniqueKey={"project_"}
                      tabDetails={tabDetails}
                      NoOfTabs={tabDetails.length}
                      onCancelClick={handleCancel}
                      onSubmitClick={handleProjectSubmitCustom}
                      onNextClick={validateTabs}
                      onEditClick={handleEdit}
                      previousNextButton={true}
                      state={state}
                      action={action}
                      breadCrumbItems={breadCrumbItems}
                      sectionLeftButton={previewSampleReportButton}
                      // headerTopButtons={headerTopButtons}
                      topButtons={
                        enterprise
                          ? action == ACTIONS.VIEW
                            ? topButtons
                            : []
                          : saasTopButtons()
                      }
                      tabValidation={tabValidation}
                      defaultSelectedValue={viewWarningOnly ? tabDetails.length : 1}
                    />
                  )}
                </>
              ) : 
              (<>
              {(action === ACTIONS.ADD || action === ACTIONS.EDIT) && (
                <>
                <FormikProvider value={formik}>
                  <TabContainer
                    uniqueKey={"firm_"}
                    tabDetails={tabDetails}
                    NoOfTabs={tabDetails.length}
                    onCancelClick={handleCancel}
                    onSubmitClick={handleSubmitCustom}
                    onNextClick={validateTabs}
                    onEditClick={handleEdit}
                    previousNextButton={true}
                    state={state}
                    action={action}
                    breadCrumbItems={breadCrumbItems}
                    sectionLeftButton={previewSampleReportButton}
                    topButtons={
                      enterprise
                        ? action == ACTIONS.VIEW
                          ? topButtons
                          : []
                        : saasTopButtons()
                    }
                    tabValidation={tabValidation}
                    defaultSelectedValue={
                      viewWarningOnly ? tabDetails.length : 1
                    }
                  />
                </FormikProvider>
                  <DialogBox
                    setShowDialogBox={setShowSelectModalityDialog}
                    showDialogBox={showSelectModalityDialog}
                    title={t("user.alert")}
                    message={noSelectionErrorMessage}
                    confirmButtonText={t("user.ok")}
                  />
                </>
              )}
              {action === ACTIONS.VIEW && (
                <TabContainer
                  uniqueKey={"firm_"}
                  tabDetails={tabDetails}
                  NoOfTabs={tabDetails.length}
                  onCancelClick={handleCancel}
                  onSubmitClick={handleSubmitCustom}
                  onNextClick={validateTabs}
                  onEditClick={handleEdit}
                  previousNextButton={true}
                  state={state}
                  action={action}
                  breadCrumbItems={breadCrumbItems}
                  sectionLeftButton={previewSampleReportButton}
                  //headerTopButtons={headerTopButtons}
                  topButtons={
                    enterprise
                      ? action == ACTIONS.VIEW
                        ? topButtons
                        : []
                      : saasTopButtons()
                  }
                  tabValidation={tabValidation}
                  defaultSelectedValue={viewWarningOnly ? tabDetails.length : 1}
                />
              )}
              </>
            )}
            </>
          )}
        </>
      )}
    </>
  );
};

export default Firm;
